import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as engagementCharter from '../engagement-charter'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: engagementCharter.RESOURCE.payload.dimension.partialId,
      partialId: engagementCharter.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Who generated or recorded this engagement charter.',
    isOptional: false,
    name: 'Actor',
    partialId: PartialId.Standard.create('actor'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
